module.exports = __webpack_public_path__ + "img/ic_32_sport_tischtennis-active.bfab3f83.svg";